export function sortBy<A>(xs: A[], fn: (x: A) => number | string) {
  return [...xs].sort((left, right) => {
    const leftResult = fn(left)
    const rightResult = fn(right)

    if (leftResult < rightResult) {
      return -1
    }

    if (leftResult > rightResult) {
      return 1
    }

    return 0
  })
}
